import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.59849 15.5753H1.38808C1.11437 15.5753 0.882812 15.8068 0.882812 16.0805V19.975C0.882812 20.2487 1.11438 20.4803 1.38808 20.4803H3.59849C3.8722 20.4803 4.10375 20.2487 4.10375 19.975V16.0805C4.12475 15.8068 3.89318 15.5753 3.59849 15.5753Z"
      fill="black"
    />
    <path
      d="M8.62974 11.9755H6.41933C6.14562 11.9755 5.91406 12.207 5.91406 12.4807V19.9539C5.91406 20.2276 6.14563 20.4592 6.41933 20.4592H8.62974C8.90345 20.4592 9.135 20.2276 9.135 19.9539V12.4807C9.135 12.207 8.92458 11.9755 8.62974 11.9755Z"
      fill="black"
    />
    <path
      d="M13.661 8.39679H11.4506C11.1769 8.39679 10.9453 8.62836 10.9453 8.90206V19.975C10.9453 20.2487 11.1769 20.4802 11.4506 20.4802H13.661C13.9347 20.4802 14.1663 20.2487 14.1663 19.975V8.90206C14.1661 8.62835 13.9345 8.39679 13.661 8.39679Z"
      fill="black"
    />
    <path
      d="M20.7557 4.46023L17.9769 1.15512C17.7663 0.923553 17.4085 0.923553 17.1981 1.15512L14.4192 4.46023C14.1455 4.79708 14.3771 5.3022 14.7981 5.3022H15.9769V19.9749C15.9769 20.2486 16.2085 20.4801 16.4822 20.4801H18.6926C18.9663 20.4801 19.1978 20.2486 19.1978 19.9749V5.3022H20.3767C20.7978 5.3022 21.0504 4.79694 20.7557 4.46023H20.7557Z"
      fill="black"
    />
  </svg>
);
export default SVGComponent;
